import { render, staticRenderFns } from "./AddBCPList.vue?vue&type=template&id=0ab6e529&"
import script from "./AddBCPList.vue?vue&type=script&lang=js&"
export * from "./AddBCPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports